import styled from "@emotion/styled";
import {
  zIndex,
  spacing,
  breakpoints,
  text,
} from "@atlas-int/tokens";
import { HeaderContainer as GlobalHeaderContainer } from "../../pages/ContentPageGrid";
import { Link } from "react-router";
import { logos } from "../../assets/icons";
import { headerLinkMetadata } from "../header/Utils";
import FlyoutMenuItem from "../header/FlyoutMenuItem";

interface NavigationBarProps {
  isHomePage?: boolean;
}

export const navBarHeight = "60px";

const HeaderContainer = styled(GlobalHeaderContainer)`
  height: ${navBarHeight};
  grid-area: unset;
  width: 100%;
  padding-left: ${spacing[2]};
  padding-right: ${spacing[2]};
  box-sizing: border-box;
  border: none;
  z-index: ${zIndex.tooltip};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const HeaderAtlasLogo = styled.div<{ isHomePage?: boolean }>`
  max-width: ${(props) => (props.isHomePage ? "250px" : "200px")};
  min-width: 100px;
  width: 100%;
  padding-left: 1rem;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 100%;
  img {
    width: 100%;
    height: auto;
    display: block;
  }

  @media (max-width: ${breakpoints.xs}) {
    display: none;
  }
`;

const HeaderNavigationList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  color: ${text.onDark};
  padding: 0;
  padding-left: 1rem;
`;

const ContentPageNav = ({ isHomePage = false }: NavigationBarProps) => {
  return (
    <HeaderContainer className="navigation-bar">
      <HeaderAtlasLogo isHomePage={isHomePage}>
        <Link to={"/"}>
          <img
            src={logos.glLogoWhite}
            alt="The Atlas of Economic Complexity"
          />
        </Link>
      </HeaderAtlasLogo>
      <HeaderNavigationList>
        {headerLinkMetadata.map((navigationLink) => {
          return (
            <FlyoutMenuItem
              key={navigationLink.routeId}
              routeId={navigationLink.routeId}
              route={navigationLink.route}
              label={navigationLink.label}
              subMenuItems={navigationLink.children}
            />
          );
        })}
      </HeaderNavigationList>
    </HeaderContainer>
  );
};

export default ContentPageNav;
